// removed by extract-text-webpack-plugin
module.exports = {"root":"SignInUp__root___2rDx4","text":"SignInUp__text___q8Z-X"};